var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorcircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/Error circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33961 3.21999C5.42332 3.21999 3.05961 5.5837 3.05961 8.49999C3.05961 11.4157 5.42335 13.78 8.33961 13.78C11.2559 13.78 13.6196 11.4157 13.6196 8.49999C13.6196 5.5837 11.2559 3.21999 8.33961 3.21999ZM2.09961 8.49999C2.09961 5.05351 4.89313 2.25999 8.33961 2.25999C11.7861 2.25999 14.5796 5.05351 14.5796 8.49999C14.5796 11.9458 11.7861 14.74 8.33961 14.74C4.89309 14.74 2.09961 11.9458 2.09961 8.49999Z",
    fill: "#AF6606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33742 5.65625C8.60251 5.65625 8.81742 5.87116 8.81742 6.13625V8.88797C8.81742 9.15306 8.60251 9.36797 8.33742 9.36797C8.07233 9.36797 7.85742 9.15306 7.85742 8.88797V6.13625C7.85742 5.87116 8.07233 5.65625 8.33742 5.65625ZM8.33985 10.3842C8.60494 10.3842 8.81985 10.5991 8.81985 10.8642V10.8948C8.81985 11.1598 8.60494 11.3748 8.33985 11.3748C8.07477 11.3748 7.85985 11.1598 7.85985 10.8948V10.8642C7.85985 10.5991 8.07477 10.3842 8.33985 10.3842Z",
    fill: "#AF6606"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorcircle);
export default __webpack_public_path__ + "static/media/Error circle.7031c2944b48e19fe60163269f24a187.svg";
export { ForwardRef as ReactComponent };